import React, {useState} from 'react'
import {Box, Divider, Grid, Grow, Typography, useTheme} from '@material-ui/core'
import {CamItem, CamResponse} from '../../data-service'
import MovieCard from '../../components/movie-card/MovieCard'
import Search from '../../components/search/Search'
import {Link} from 'react-router-dom'

interface MainProps {
    data: CamResponse;
    useThemeHook?: any;
}

export default function Main({data, useThemeHook = useTheme}: MainProps) {
	const theme = useThemeHook()
	const spacing: number = theme.spacing()
	const [query, setQuery] = useState<string>('')

	const onQueryChange = (query: string) => {
		setQuery(query)
	}

	const dataToPresent: { catTitle: string, items: CamItem[] }[] = data.cats
		.map(cat => ({
			catTitle: cat.title,
			items: data.items
				.filter(item => item.cat === cat.id)
				.filter(item => item.title.toLocaleLowerCase().includes(query.toLocaleLowerCase()))
		}))
		.filter(el => el.items.length > 0)

	return (<>
		<Search onQueryChange={onQueryChange} query={query}/>

		{dataToPresent.map((cat, catindex) => <Grid
			key={catindex}
			style={{backgroundColor: 'transparent', minHeight: '35vh'}}
			container
			spacing={2}
			direction="row"
			justifyContent="flex-start"
			alignItems="stretch"
		>

			<Grid item xs={12}>
				<Typography gutterBottom variant="h5" component="h1">
					{cat.catTitle}
				</Typography>
			</Grid>

			<Grid
				container
				spacing={2}
				direction="row">
				{cat.items
					.map((item, itemIndex) =>
						<Grow
							key={item.id}
							in={true}
							style={{transformOrigin: '0 0 0'}}
							{...({timeout: itemIndex * 150})}
						>
							<Grid item xs={6} sm={4} md={3}>
								<Link to={`/stream/${item.id}`} style={{textDecoration: 'none'}}>
									<MovieCard title={item.title} id={item.id} description={item.description}
										poster={`//www.tarnow.net.pl/uploads/stream_service_items/VGA/${item.img}`}/>
								</Link>
							</Grid>
						</Grow>)}
			</Grid>

			{catindex !== (data.cats.length - 1) && <Grid item xs={12}>
				<Divider style={{marginTop: `${spacing * 2}px`, marginBottom: `${spacing * 2}px`}}
					orientation="horizontal"/>
			</Grid>}
		</Grid>)}</>)
}